//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passCesium3DTileClassificationIgnoreShow = 6.0;\n\
";
